import {
  gsap
} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import {
  onEnterBackFunction,
  applyGradientLine,
  onEnterFunction,
  onLeaveBackFunction,
  onLeaveFunction,
  removeClassBySubstring
} from './helpers';
// import bodymovin from 'bodymovin';

export function pageAboutUi(container) {
//  console.log('pageAboutUi', container);
  //review usage:
  gsap.registerPlugin(ScrollTrigger);

  // we need to figur ou how to adress resizing of values - i.e move variables into a resize function

  let gradientLineContainer = document.querySelector('.line-container'),
    gradientLine = gradientLineContainer.querySelector('.line'),
    linkTarget = "about", // for gradient line

  // let resources = container.querySelector('.article__content'); // was using this but better naming conventoin:
    articleContent = container.querySelector('.article__content'),
    introContent = container.querySelector('.block--about-intro'),
    introContentAbout = container.querySelector('.block--about-intro'),
    // type of content - used to determine filter type
    // type = "page", //aka initiator -aka Related Posts Resourcds
    // containerYype - used to determined function options based on Dom container
    // containerType = "pre-transform", // dentoing that this runs after the barba change ; data.next.container
    postTransformContent = container.querySelector('.--post-transform'),
    timelineNav = articleContent.querySelector('.timeline__nav'),
    pageNavLinks = articleContent.querySelectorAll('.page__nav-links li'),
    pageNav = articleContent.querySelector('.page__nav'),
    contentCv = articleContent.querySelector('.cv__content'),
    pageHeader = articleContent.querySelector('.page__header'),
    narrativeCv = articleContent.querySelector('.cv__narrative'),
    videoCv = articleContent.querySelector('.cv__video'),
    contactCv = articleContent.querySelector('.cv__contact'), 
    narrativeCvNavItems = articleContent.querySelectorAll('.cv__narrative-nav .cv__narrative-item'),
    narrativeCvNavContainer = articleContent.querySelectorAll('.cv__narrative-nav .cv__narrative-nav-container'),
    narrativeCvNav = articleContent.querySelector('.cv__narrative-nav'),
    narrativeCvItems = articleContent.querySelectorAll('.cv__narrative-items .cv__narrative-item'),
    narrativeCvItem = articleContent.querySelector('.cv__narrative-items'),
    narrativeCvFirstNavItem = narrativeCvNav.querySelector('.cv__narrative-item[data-narrative-item-id="1"]'),
    narrativeCvFirstItem = narrativeCvItem.querySelector('.cv__narrative-item[data-narrative-item-id="1"]'),

    // tl start value
    narrativeCvScrollerStart = (pageHeader.offsetHeight + pageNav.offsetHeight + narrativeCvNav.offsetHeight),
    narrativeCvTriggerStart = 0,
    introContentScrollerStart = (pageHeader.offsetHeight + pageNav.offsetHeight + narrativeCvNav.offsetHeight),
    introContentTriggerStart = 0,

    tlAbout = new gsap.timeline(),
    tlAboutPause = true, // this will allow me to pause the timeline when needed
    markersVal = false;


  // console.log("narrativeCvScrollerStart", narrativeCvScrollerStart);
  // console.log("pageHeader.offsetHeight, pageNav.offsetHeight, narrativeCvNav.offsetHeight");
  // console.log(pageHeader.offsetHeight, pageNav.offsetHeight, narrativeCvNav.offsetHeight);
  // console.log("timelineNav", timelineNav);

  //header line - if - active gradient line

  applyGradientLine(gradientLine, linkTarget);

  //end header line - if - active gradient line

  if (postTransformContent.toString().length > 0) {
    // console.log("HERE ---   postTransformContent exists in Page: About", postTransformContent);
    // chekc if intro block exists - if not - sack this animaton sequence off?

    if (introContent.toString().length > 0) {

      var image = introContent.querySelector('#about-intro-image'),
        text = introContent.querySelector('#about-intro-text'),
         transposedImage = postTransformContent.querySelector('.panel__body .panel__body-image'), 
        transposedText = postTransformContent.querySelector('.panel__body .panel__body-description');
      var imageBounds = image.getBoundingClientRect();
      var textBounds = text.getBoundingClientRect();

      // gsap.set(transposedImage, { 
      //   x: imageBounds.left,
      //   y: imageBounds.top,
      //   width: imageBounds.width,
      //   height: imageBounds.height,
      //   opacity: 0.2,
      // });

      // gsap.set(transposedText, { 
      //   x: textBounds.left,
      //   y: textBounds.top,
      //   width: textBounds.width,
      //   height: textBounds.height,
      //   opacity: 0.2,
      // });

      // console.log("image", image);
      // console.log("text", text);
      // console.log("transposedImage", transposedImage);
      // console.log("transposedText", transposedText);

      // console.log("imageBounds", imageBounds);
      // console.log("textBounds", textBounds);

      tlAbout
        // .to(image, { 
        //   opacity: 0.2,
        //   duration: 1,
        //   ease: "power1.inOut",
        // }, "0")
        // .to(text, {
        //   opacity: 0.2,
        //   duration: 1,
        //   ease: "power1.inOut",
        // }, "0") 
        // .to([image, text], { 
        //   opacity: 0.2,
        //   duration: 1,
        //   ease: "power1.inOut",
        // }, "0")
        // .to([transposedImage, transposedText], {
        //   opacity: 1,
        //   duration: 1,
        //   ease: "power1.inOut",
        // }, "0") 
        // .to(transposedImage, {
        //   x: imageBounds.left,
        //     y: imageBounds.top,
        //     width: imageBounds.width,
        //     height: imageBounds.height,
        //     // opacity: 0.2,
        // }, "2") // review this timing
        // here we animate - moe the tansposed image and text into view
        //add rules accordingluy
        //end here we animate - moe the tansposed image and text into view
        .fromTo(postTransformContent, {
          opacity: 1,
        }, {
          opacity: 0,
          // PointerEvents: "none",
        }, "<") // review this timing

        .fromTo(articleContent, {
          opacity: 0,
          zIndex: 20, // review this in later tranistional contextss
        }, {
          opacity: 1,
          zIndex: 2,
        }, "<") // review this timing

    }

  } //postTransformContent.toString().length > 0

  // toggles for narrative or list view
  pageNavLinks.forEach((navItem) => {
    // review this js logic-  im not sure its fully working as expected
   console.log("navItem", navItem);

    navItem.addEventListener('click', function (event) {
      // console.log("navItem - click", navItem);

      var link = navItem.getAttribute('data-nav-link');
      // console.log("link to activate", link);

      if (navItem.classList.contains("--active")) {

        var activeItem = pageNav.querySelector('.--active'); // if ther eis nothing else active - then don't do anything

        if (activeItem != null && (activeItem.getAttribute('data-nav-link') != navItem.getAttribute('data-nav-link'))) {
          navItem.classList.remove("--active");
          contentCv.querySelector(`.cv__${link}`).classList.remove("--active");
          removeClassBySubstring(container, "-about-active"); // remove 

        }


      } else {

        // console.log("pageNavLinks", pageNavLinks);
        // console.log("pageNavLinks", pageNavLinks.classList);

        var activeItem = pageNav.querySelector('.--active');

        if (activeItem != null) {
          activeItem.classList.remove("--active"); //remove others
          removeClassBySubstring(container, "-about-active"); // remove others

          // contentCv.querySelectorAll('.cv__content-item')''.classList.remove("--active"); // remove othres

          contentCv.querySelectorAll('.cv__content-item').forEach((item) => {
            item.classList.remove("--active");
          });
        }

        contentCv.querySelector(`.cv__${link}`).classList.add("--active"); // add active to this one
        navItem.classList.add("--active");

        container.classList.add(`--${link}-about-active`); // add to body
        // scroll to the top of the list or narrative
        //review changing this for the list - need more space
        window.scroll({
          top: contentCv.querySelector(`.cv__${link}`).offsetTop,
          left: 0,
          behavior: 'smooth'
        });

      }

    });

  });

  //end toggles for narrative or list view

  if (narrativeCv.toString().length > 0) {

    // console.log("(narrativeCV.toString().length > 0)",  narrativeCv);
    // assigned width to the date nav - based on a proporiante an d% based 
    var totalHeight = narrativeCv.offsetHeight; // make sure there is re-size function attached to this + refresh the tl?

    if (narrativeCvItems.toString().length > 0) {

    // console.log("narrativeCvItems", narrativeCvItems);

      narrativeCvItems.forEach((item) => {
        // console.log("item", item);
        var itemHeight = item.offsetHeight;
        var assignHeight = (itemHeight / totalHeight) * 100;
        var itemID = item.getAttribute("data-narrative-item-id");
        // console.log("itemID", itemID);

        // console.log("assignHeight", assignHeight);
        item.setAttribute("data-height", assignHeight); //= assignHeight + "%";
        // I also needs to the sat the same data width to the nav item
        var navItem = narrativeCvNav.querySelector('.cv__narrative-item[data-narrative-item-id="' + itemID + '"]');
        // console.log("navItem", navItem);

        navItem.setAttribute("data-width", assignHeight) //not really needed maybe now:
        navItem.style.setProperty('--data-width', assignHeight); //setting widths in css calc

        // console.log("stickyEl", stickyEl);

        var stickyEl = item.querySelector('.cv__narrative-image');
        // thi s maybe be flawwed in the context that In some instances I coiuld have more than 1 row (acf frepear) for images
        // so setting classes on parents where the child might not always be sticky yet is pointless.

        // maybe I need to re-addpoint my thinking aand use this approach sclighly different
        // the  aims is to _ potentially animate in the opacity of images based on being active or not

        if (stickyEl == null) {
          // console.log("no stickyEl");
          return;
        } else {

          var parentEl = stickyEl.closest(".cv__narrative-item"); //item; //
          var prevParentSiblingEl = parentEl.previousElementSibling;

          // console.log("stickyEl", stickyEl);
          // console.log("parentEl", parentEl);
          // console.log("prevParentSiblingEl", prevParentSiblingEl);

          const handler = (entries) => {
            // console.log(entries)

            if (!entries[0].isIntersecting) {
              stickyEl.classList.add('--is-sticky');
              parentEl.classList.add('--parent-is-sticky');
              // document.querySelector('.target').innerHTML = "Now Sticky Styled";

            } else {
              stickyEl.classList.remove('--is-sticky');
              parentEl.classList.remove('--parent-is-sticky');
              // document.querySelector('.target').innerHTML = "Not Sticky Styled";

            }
          }

          // create the observer
          const observer = new window.IntersectionObserver(handler);
          // give the observer some dom nodes to keep an eye on
          observer.observe(prevParentSiblingEl);
          // END - revie this thi s maybe be flawwed in the context that In some instances I coiuld have more than 1 row (acf frepear) for images

        }

      });


    }
  }

  // set up tl and scroll trigger for the narrative cv items
  // console.log("narrativeCvScrollerStart", narrativeCvScrollerStart);

  // ensure that this refresehes when we toggle between list and narrative view:
  let tlNavigationAnimate = new gsap.timeline({
    defaults: { // children inherit these defaults
      // duration: 5,
      // ease: "slow(0.5,0.7,false)" //review this easing value - fucking shite.
      ease: "linear", // ensure its linear - otherwise nav and items doen't align throughout whole scroll experience

    },
    scrollTrigger: {
      trigger: narrativeCvItem, //review
      force3D: true,
      start: `-${narrativeCvTriggerStart}px ${narrativeCvScrollerStart}px`,
      end: `100% 100%`, // [trigger] [scroller] positions -- if its not near the end - the the end items never reach each other  - which also fucks up the alignment of timelines dates
      scrub: true,
      // markers: markersVal,
      onEnter: () => onEnterFunction(container, narrativeCv, "--narrative-tl-active"), //start
      onLeave: () => onLeaveFunction(container, narrativeCv, "--narrative-tl-active"), //end
      onEnterBack: () => onEnterBackFunction(container, narrativeCv, "--narrative-tl-active"), // header state
      onLeaveBack: () => onLeaveBackFunction(container, narrativeCv, "--narrative-tl-active"), // header state

    }, //scrollTrigger

  });

  tlNavigationAnimate
    .add(function () {
  // console.log(' tlNavigationAnimate  - start');
    }, "0")
    .fromTo(narrativeCvFirstItem, {
      opacity: 1,
    }, {
      opacity: 0.5,
    }, "0")
    .fromTo(narrativeCvNavContainer, { // need to ensure images are loaded
      x: '0',
    }, {
      // y: ((10 * ratio) + 90) + "vh", // pass variable into height change (ratio)
      x: '-100%',
    }, "0")
    .add(function () {
    //  console.log('tlNavigationAnimate- end')
    }, ">");

/// animate the intro content
//check if intro content exists

if (introContent.toString().length > 0) {


  var image = introContent.querySelector('#about-intro-image'),
  text = introContent.querySelector('#about-intro-text'),
  //  transposedImage = postTransformContent.querySelector('.panel__body .panel__body-image'), 
  // transposedText = postTransformContent.querySelector('.panel__body .panel__body-description');
  imageBounds = image.getBoundingClientRect(),
   textBounds = text.getBoundingClientRect();

let tlIntroAnimate = new gsap.timeline({
    defaults: { // children inherit these defaults
      // duration: 5,
      // ease: "slow(0.5,0.7,false)" //review this easing value - fucking shite.
      ease: "linear", // ensure its linear - otherwise nav and items doen't align throughout whole scroll experience

    },
    scrollTrigger: {
      trigger: introContent, //review
         force3D: true,
      //  start:  `-${narrativeCvTriggerStart}px ${narrativeCvScrollerStart}px`, //
      start:`${introContentTriggerStart}px ${introContentScrollerStart}px`, 
      // end: "bottom top",
       end: `100% ${introContentScrollerStart}px`, // [trigger] [scroller] positions -- if its not near the end - the the end items never reach each other  - which also fucks up the alignment of timelines dates
      scrub: true,
        markers: markersVal,
      // onEnter: () => onEnterFunction(container, narrativeCv, "--narrative-tl-active"), //start
      // onLeave: () => onLeaveFunction(container, narrativeCv, "--narrative-tl-active"), //end
      // onEnterBack: () => onEnterBackFunction(container, narrativeCv, "--narrative-tl-active"), // header state
      // onLeaveBack: () => onLeaveBackFunction(container, narrativeCv, "--narrative-tl-active"), // header state

    }, //scrollTrigger

  });

  tlIntroAnimate
    .add(function () {
  //  console.log('tlIntroAnimate - start');
    }, "0")
    .fromTo(image, {
      opacity: 1,
      // x: '0',
        y:  "0",
      scale:1,
    }, {
      // opacity: 0.8,
      // x: '-100%',
       y: '100%',
       scale:0
    }, "<")
    .fromTo(text, {
      // opacity: 1,
      // x: '0',
       scale:1,
    }, {
      scale:0
      // x: '-100%',
      // scale:1.4,
    }, "<")
    // .fromTo(introContent, {
    //   opacity: 1,
    // }, {
    //   opacity: 0.8,
    // }, "<")
    // .fromTo(narrativeCvNavContainer, { // need to ensure images are loaded
    //   x: '0',
    // }, {
    //   // y: ((10 * ratio) + 90) + "vh", // pass variable into height change (ratio)
    //   x: '-100%',
    // }, "0")
    .add(function () {
      // console.log('tlIntroAnimate -  end')
    }, ">");



  }

}